module.exports = __webpack_public_path__ + "static/media/message-orange.cd503231.svg";